<style lang="scss">
.logout-challenge {
  .input-group {
    box-shadow: unset !important;
  }
}
</style>

<!-- eslint-disable -->
<template>
  <div class="logout-challenge">
    <validation-observer ref="observer" v-slot="{ handleSubmit }">
      <b-form @submit.stop.prevent="handleSubmit(tryLogout)">
        <section class="mb-1">
          <validation-provider
            v-slot="validationContext"
            name="Password"
            :rules="{ required: true }"
          >
            <b-input-group class="mb-1">
              <label class="d-block full-width">Please enter your password to logout</label>
              <b-form-input v-model="logoutPassword" :type="'password'" autocomplete="off"
                            :rules="{ required: true }"
                            :state="getValidationState(validationContext)" required
                             placeholder="Enter your password"
              />
              <small class="text-danger full-width mt-1">{{ validationContext.errors[0] }}</small>
            </b-input-group>
          </validation-provider>
        </section>

        <section class="d-inline-flex full-width mt-2 border-top pt-1">
          <div class="ui-spacer"/>
          <b-button class="mr-1" @click="$emit('logout', false)">Cancel</b-button>
          <b-button :class="{'disabled': submitting}" variant="primary" type="submit" class="d-flex align-items-center">
            <span>Logout</span>
            <b-spinner class="ml-1" v-if="submitting" variant="white" label="Loading"></b-spinner>
          </b-button>
        </section>
      </b-form>
    </validation-observer>
  </div>
</template>
<!-- eslint-enable -->

<script>
import PrisonUsersService from '@/services/PrisonUsersService';

export default {
  components: {},
  props: {},
  data() {
    return {
      logoutPassword: '',
      submitting: false,
    };
  },
  mounted() {

  },
  methods: {
    tryLogout() {
      this.submitting = true;
      PrisonUsersService.logoutChallenge(this.logoutPassword).then(() => {
        this.$emit('logout', true);
        this.$toast.success('Successfully logged out', {
          toastClassName: ['toast-std', 'success-toast'], timeout: 4000,
        });
      }).catch(() => {
        this.logoutPassword = '';
        this.$toast.error('Your logout challenge failed, please check your password and try again', {
          toastClassName: ['toast-std', 'warning-toast'], timeout: 5000,
        });
      }).finally(() => {
        this.submitting = false;
      });
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
  },
};
</script>
